// Helper functions
const getDomain = (hostname: string[]): string => 
  hostname.includes('dsa') || hostname.includes('imobiliare') ? 'finance.imobiliare.ro' : 'lendi.pl';

const getEnvironment = (hostname: string[]): string => {
  if (hostname.includes('localhost')) return 'qa';
  if (hostname.includes('qa')) return 'qa';
  if (hostname.includes('vercel')) return 'qa';
  if (hostname.includes('demo')) return 'demo';
  return 'production';
};

const setWindowProperty = (key: string, value: any): void => {
  Object.defineProperty(window, key, { value, writable: false });
};

// Main configuration
const hostname = window.location.hostname.split('.');
const domainQuery = new URL(document.location.toString()).searchParams.get('domain');
const isFeatureBranchOrDevEnvironment = process.env.VUE_APP_VERCEL_ENV === 'preview' || 
                        process.env.VUE_APP_ENV === 'DEV';

// Set environment
setWindowProperty('__ENV__', getEnvironment(hostname));

// Set domain
if (isFeatureBranchOrDevEnvironment) {
  const sessionDomain = sessionStorage.getItem('__DOMAIN__');
  const domain = domainQuery === 'dsa' ? 'finance.imobiliare.ro' : 'lendi.pl';

  if (sessionDomain && !domainQuery) {
    setWindowProperty('__DOMAIN__', sessionDomain);
  } else {
    setWindowProperty('__DOMAIN__', domain);
    if (domainQuery) {
      sessionStorage.setItem('__DOMAIN__', domain);
    }
  }
} else {
  // do zmiany jak będzie produkcja na vercelu
  setWindowProperty('__DOMAIN__', process.env.VUE_APP_APP_DOMAIN);
}

// Set domain prefix
setWindowProperty('__DOMAIN_PREFIX__', 'platforma');

export default {};
